export default __webpack_public_path__ + "static/media/car-hybrid-zero.851eb7e8.svg";